import React from 'react';
import './HeaderIT.css';
import Logo from '../../../assets/rewboxlogo3.png';
import { Link } from 'react-router-dom';

const HeaderIT = ({ backcolor = `rgb(56, 209, 107)` }) => {
  return (
    <div
      className="sr-header-container"
      style={{ background: `linear-gradient(to right, ${backcolor}, #FFD700)` }}
    >
      <div className="header-left-item">
        <img className="header-logo1" src={Logo} alt="Logo"></img>
      </div>
      <div className="header-right-item">
        <Link to="/it/termini" target="_blank" rel="noopener noreferrer">
          TERMINI E CONDIZIONI
        </Link>
      </div>
    </div>
  );
};

export default HeaderIT;
